import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDataCatalogLineageLensWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-6.625L8 20v-5H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h14Zm0 1H5v8h4v3.338L11.921 14H19V6Zm-5 2v5h-1V8h1Zm-2-1v6h-1V7h1Zm-2 2v4H9V9h1Z"
      fill="#fff"
    />
  </svg>
);
const Memo = memo(SvgDataCatalogLineageLensWhite);
export default Memo;
